<template>
  <div class="container">
    <img class="logo-img" src="../assets/logo.png" />
    <div class="card-box">
      <div class="caption">Login</div>
      <div class="tip">Login in with email and password</div>
      <br>
      <el-form :model="form" :rules="rules" label-width="0px">
        <el-form-item label prop="account">
          <el-input
            v-model="form.account"
            size="large"
            :style="{width:'438px'}"
            placeholder="Please enter email"
            autofocus
          ></el-input>
        </el-form-item>
        <!-- <el-divider></el-divider> -->
        <br>
        <el-form-item label prop="password">
          <el-input
            v-model="form.password"
            size="large"
            :style="{width:'438px'}"
            placeholder="Please enter password"
            show-password
            @keyup.enter.native="onSubmit"
          ></el-input>
        </el-form-item>
        <!-- <el-divider></el-divider> -->
        <br>
        <br>
        <el-form-item>
          <el-button type="primary" @click="onSubmit" :style="{width:'438px'}">
            Login&nbsp;&nbsp;
            <i class="el-icon-s-promotion"></i>
          </el-button>
        </el-form-item>
      </el-form>
      <!-- <div class="forget">
        or
        <a href="/password/reset">Forgot Password?</a>
      </div> -->
      <br>
      <br>
    </div>
    <div class="footer">
      <a
        class="footer-link"
        href="#"
        target="_blank"
      >© 2024 Marvel Tyres</a>
    </div>
  </div>
</template>

<script>
import { Message } from 'element-ui'
import { mapActions } from 'vuex'

export default {
  name: 'Login',
  data () {
    return {
      form: {
        account: '',
        password: ''
      },
      rules: {
        account: [
          {
            type: 'email',
            required: true,
            message: 'Please enter your email',
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            message: 'Please enter your password',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    ...mapActions({
      login: 'oauth/loginAction'
    }),
    async onSubmit () {
      // 仓库及司机不能登录
      const roleNum = Number(localStorage.getItem('role'))
      const isWhsStaff = roleNum === 5 || roleNum === 6
      if (isWhsStaff) {
        Message.error({
          showClose: true,
          duration: 3500,
          dangerouslyUseHTMLString: true,
          message: 'No access permission for warehouse staff.'
        })
        return
      }

      try {
        await this.login({ form: this.form })
        this.$router.push('/')
      } catch (error) {
        Message.error({
          showClose: true,
          duration: 5000,
          dangerouslyUseHTMLString: true,
          message: 'Login failed. Incorrect email or password'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  background-color: #080808;
  display: flex;
  flex-flow: column wrap;
  align-content: center;
  align-items: center;
  min-height: 100%;
}

.logo-img {
  height: 30px;
  margin-top: 150px;
}

.card-box {
  margin-top: 100px;
  position: relative;
  max-width: 520px;
  padding: 40px;
  border: 1px solid #EE1C25;
  border-radius: 5px;
  .caption {
    color:#fff;
    font-size: 36px;
    text-align: center;
    margin-bottom: 37px;
  }
  .tip {
    color:#fff;
    text-indent: 8px;
    font-size: 14px;
    margin-bottom: 14px;
  }
  .forget {
    color: #888;
    text-align: center;
    font-size: 13px;
    margin: 36px 0px 26px 0px;
    a {
      color: #EE1C25;
      text-decoration: none;
    }
  }
}

.el-divider {
  margin: 10px 0;
  background-color: #fafafa;
}
.footer-link {
  color: #888;
  text-decoration: none;
  text-align: center;
  display: block;
  margin-top: 140px;
  font-size: 12px;
}
</style>
